export default __webpack_public_path__ + "e9620db55e7710966c1a999cfdfec2fd.png";